import { render, staticRenderFns } from "./EcommerceUsersMain.vue?vue&type=template&id=3c645d7c&"
import script from "./EcommerceUsersMain.vue?vue&type=script&lang=js&"
export * from "./EcommerceUsersMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports